export const NAME = 'stores';